var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0659 16.6862H4.4969L13.8653 7.31776L12.4464 5.89276L3.0659 15.2732V16.6862ZM0.796875 18.9612V14.3286L13.9849 1.15959C14.1929 0.964304 14.4237 0.814671 14.6773 0.710687C14.9309 0.606687 15.1971 0.554688 15.4757 0.554688C15.7503 0.554688 16.0186 0.606687 16.2806 0.710687C16.5425 0.814671 16.7732 0.970645 16.9724 1.17861L18.6045 2.81774C18.8125 3.01304 18.9653 3.24266 19.0629 3.50661C19.1606 3.77056 19.2094 4.0355 19.2094 4.30144C19.2094 4.58007 19.1606 4.8472 19.0629 5.10281C18.9653 5.35843 18.8125 5.59022 18.6045 5.79819L5.44145 18.9612H0.796875ZM13.1463 6.61176L12.4464 5.89276L13.8653 7.31776L13.1463 6.61176Z",
    fill: "#515253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ceda4b7e87bb7f40e6652d645d6e197f.svg";
export { ForwardRef as ReactComponent };